import { render, staticRenderFns } from "./CheckListForm.vue?vue&type=template&id=0b009617"
import script from "./CheckListForm.vue?vue&type=script&lang=js"
export * from "./CheckListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports